module.exports = __webpack_public_path__ + "img/e_3_24_g.d66e227a.png";